export default __webpack_public_path__ + "static/media/google_play_app.6ad01d07.png";